import { createHandlerChainRunner, CustomHandler } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = CustomHandler<{ isGeoPermissionDenied: string }>;

export const DispatchSetGeoPermission: CustomHandlerType = ({ dispatch, parameter: { isGeoPermissionDenied } }) => {
    dispatch({
        type: "Custom/SetGeoPermission",
        isGeoPermissionDenied,
    });
};

export const chain = [DispatchSetGeoPermission];

const setGeoPermission = createHandlerChainRunner(chain, "SetGeoPermission");
export default setGeoPermission;
